module.exports = __webpack_public_path__ + "static/635759292.6c8c0bfe.jpg";